import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Bonus } from '@/types';
import { useDeleteBonusMutation } from '@/services';

export interface DeleteBonusProps extends DialogProps {
  bonus: Bonus;
  onClose(): void;
}

const DeleteBonus: React.FC<DeleteBonusProps> = ({ bonus, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteBonus, deleteBonusResponse] = useDeleteBonusMutation();

  async function handleDeleteBonus() {
    try {
      await deleteBonus(bonus).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{bonus?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{bonus?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteBonusResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteBonusResponse.isLoading} onClick={handleDeleteBonus}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteBonus;
